// src/store/modules/statistics/dispatchStatistics/getChartData.js

function getThemeValue(name, fallback = '#ff00ff') {
	const root = document.documentElement;
	const value = getComputedStyle(root).getPropertyValue(name).trim();
	return value || fallback;
}

export default function getChartData({ labels, amount, mileage }) {
	return {
		labels,
		pointHitDetectionRadius: 1,
		datasets: [
			{
				yAxisID: "a",
				label: "Gross",
				data: amount,
				order: 1,
				hidden: null,
				barThickness: 100,
				borderRadius: 4,
				backgroundColor: getThemeValue('--chart-bar-gross', 'rgba(25, 188, 56, 0.75)'),
			},
			{
				yAxisID: "b",
				label: "RPM",
				fill: {
					target: 'origin',
					above: getThemeValue('--chart-line-fill', 'rgba(143, 144, 166, 0.38)'),
				},
				data: mileage,
				order: 2,
				backgroundColor: getThemeValue('--chart-line-bg', '#ff0000'),
				borderColor: getThemeValue('--chart-line-border', 'rgb(82,255,203)'),
				tension: 0.5,
				type: "line",
			},
		],
	};
}
